import React, { useEffect, useState } from "react";
import {
  Chip,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  useTheme,
} from "@material-ui/core";
import { connect } from "react-redux";
import styles from "../styles/global-styles";
import TableHeadGuarantee from "../components/stateless/headTables/TableHeadGuarantee";
import StyleTableRow from "../styles/styleTableRow";
import StyledTableCell from "../styles/tableCell";
import { GuaranteeService } from "../services/guarantee.service";
import { actions } from "../redux/actions/alert";
import { AuthService } from "../services/auth.service";
import { UserService } from "../services/user.service";
import { changeRowsPerPage, customDate, sliceText } from "../_utils/utils";
import HeaderGuaranteeContainer from "../components/core/guarantee/HeaderGuaranteeContainer";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  label: styles.label,
  table: {
    minWidth: 700,
  },
  subtitle: styles.subtitle,
  row: styles.rowHover,
  chip: styles.chip,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  statusGuarantee: styles.statusGuarantee,
  chipProduct: styles.chipProductType,
}));

const ContainersGuaranteesInSite = ({
  addAlert,
  detailAlert,
  history: { push },
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [guaranteeArray, setGuaranteeArray] = useState([]);
  /** Pagination */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    (async () => {
      try {
        const { id, siteId } = AuthService.currentUserValue;
        const { data } = await UserService.getUserById(id);
        if (data.siteId === siteId) {
          const { data } = await GuaranteeService.getAllGuarantees();
          console.log("data getGuaranteesBySite", data);
          setGuaranteeArray(data);
        } else {
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message:
              "No se puede recuperar las garantías de la sucursal que solicitaste",
          });
        }
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const goToUrl = (url) => push(url);

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleRowsPerPage = (event) => {
    const { rowsPerPage, page } = changeRowsPerPage(event);
    setRowsPerPage(rowsPerPage);
    setPage(page);
  };

  const handleGuaranteesByFilter = (result, isSuccess) => {
    if (isSuccess) {
      setGuaranteeArray(result);
      setPage(0);
      console.log("typeof page", typeof page);
    } else {
      console.log("no results found", result);
      addAlert({ showAlert: true });
      detailAlert({
        severity: result.noData ? "warning" : "error",
        message: result.noData ? result.noData : result.msgs,
      });
    }
  };

  return (
    <>
      <HeaderGuaranteeContainer
        guaranteeResults={handleGuaranteesByFilter}
        inSite
      />
      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          {guaranteeArray.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              <>
                <TableHeadGuarantee showSites={true} />
                <TableBody>
                  {guaranteeArray
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, i) => (
                      <StyleTableRow
                        key={i}
                        className={classes.row}
                        onClick={() =>
                          goToUrl(`/dashboard/inventario/garantia/${row.id}`)
                        }
                      >
                        <StyledTableCell>
                          {row.serviceTicket || ""}
                        </StyledTableCell>
                        <StyledTableCell style={{ fontWeight: 700 }}>
                          {row.site?.name || "N/A"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Chip
                            label={row.product?.product_type?.name || "N/A"}
                            className={classes.chipProduct}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          style={{ fontWeight: 800 }}
                        >
                          {row.product?.product_type?.id === 1
                            ? row.product?.movile?.imeiCode
                            : "N/A"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.client.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.product.movile?.brand}{" "}
                          {row.product.movile?.model}{" "}
                          {row.product.accesory?.brand}{" "}
                          {row.product.accesory?.model}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {sliceText(row.failureDetail, 50)}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Chip
                            label={row.status_guarantee?.name || "---"}
                            className={classes.statusGuarantee}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.tipification_guarantee?.name || "---"}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {customDate(row.createdAt)}
                        </StyledTableCell>
                      </StyleTableRow>
                    ))}
                </TableBody>
              </>
            </Table>
          ) : (
            <h2> Seleccionar filtros para garantías</h2>
          )}
        </TableContainer>
        {guaranteeArray.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={guaranteeArray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => handleRowsPerPage(event)}
          />
        )}
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ContainersGuaranteesInSite);
